import { render, staticRenderFns } from "./createList.vue?vue&type=template&id=c7d54fba&scoped=true"
import script from "./createList.vue?vue&type=script&lang=js"
export * from "./createList.vue?vue&type=script&lang=js"
import style0 from "./createList.vue?vue&type=style&index=0&id=c7d54fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d54fba",
  null
  
)

export default component.exports